<template>
<v-container fluid grid-list-xs>
<v-layout row wrap fill-height
  v-if="!dialog">
<v-flex xs12 md2 order-xs1 order-md1>
  <div class="fixed">
    <h3 >Dane kontaktowe</h3>
  <v-form
  class="mt-2"
  v-if="!iHaveName"
  v-model="valid">
    <v-text-field
      v-model="name"
      :rules="nameRules"
      label="Imię i Nazwisko"
      required
      box
    ></v-text-field>
    <v-text-field
      v-model="email"
      label="E-mail"

      box
    ></v-text-field>
    <v-text-field
      v-model="phone"
      label="Telefon"
      mask="###########"
      box
    ></v-text-field>
  </v-form>
  </div>
</v-flex>
<v-flex xs12 md6 offset-md1 order-xs3 order-md2> 
       <v-list three-line
       class="dis-padding">
         <template
         v-for="(item, idx) in question">
          <v-list-tile
          class="hovertrans"
          v-bind:class="{'xsize-list': xsmallList, 'size-list': smallList}"
            :key="item+idx"
            @click=""
          >
          <v-flex xs12 md9 >
            <v-list-tile-content>
              <!-- <span><v-list-tile-title v-text="item.id"></v-list-tile-title> -->
              <!-- <span>{{item.id}}. some textasssssssssssssssssssssssssssssssssssssdddddd 233333333333 2sdasdas - oasdasd asasdasdasdasdadaadadadasd ooasdasd</span> -->

              <!-- <v-list-tile-title v-text="item.id"></v-list-tile-title> -->
              <div class="text-xs-left">{{item.id}}. {{item.question}}</div>
            </v-list-tile-content>
          </v-flex>
          <v-flex xs4 md3 >
            <v-list-tile-action-text class="v-radio-button-end">
              <v-radio-group
              class="text-md-right"
              row
              v-model="answer[item.id]"
              >
                <v-radio
                    v-for="n in ['Tak' ,'Nie']"
                    :key="n"
                    :label="` ${n}`"
                    :value="mapValue[n]"
                    color='pink'
                ></v-radio>
              </v-radio-group>
            </v-list-tile-action-text>
          </v-flex>
          </v-list-tile>
            <v-divider
              v-if="idx + 1 < question.length"
              :key="idx"
            ></v-divider>
         </template>
        </v-list>
</v-flex>
<v-flex xs12 md2 offset-md1 order-xs2 order-md3>
    <div class="fixed">
             <v-card color="grey darken-1" class="white--text">
              <v-card-title primary-title>
                <div class="headline">Informacje</div><br>
              </v-card-title>
              <v-card-text>
            <div class="text-xs-left">Jeżeli zgadzasz sie ze stwiedzeniem zaznacz <b>Tak</b></div>
            <div class="text-xs-left">lub <b>Nie</b> jeżeli nie zgadasz się</div>

              </v-card-text>
            </v-card>
    </div>
</v-flex>
<!-- <v-flex xs12>
        <v-btn fab small color="pink" @click.native="prevPage()" :disabled="page === 1">
      <v-icon >arrow_back_ios</v-icon>
    </v-btn>
        <v-btn fab small color="pink" @click="nextPage()" :disabled="page === question.length || answer[page] === undefined">
      <v-icon dark>arrow_forward_ios</v-icon>
        </v-btn>
</v-flex> -->
<v-flex xs12 mt-4 order-xs4 order-md4>
        <v-btn
        round
      color="pink"
      class="white--text"
      @click.native="clearAnswers"
    >
      Wyczyść odpowiedzi
      <v-icon right dark>cancel</v-icon>
    </v-btn>
        <v-btn
        round
      :disabled="Object.keys(answer).length !== question.length || notSendSecond !== false"
      color="pink"
      class="white--text"
      @click.native="sendAnswers"
    >
      Wyślij odpowiedzi
      <v-icon right dark>send</v-icon>
    </v-btn>
</v-flex>
<!-- <v-flex xs12
v-if="messLocalStorage"
>
    <h3>Juz jeden test zostal wyslany!</h3>
</v-flex> -->
<v-flex xs12 order-xs5 order-md5
    v-if="errorName !== '' && name === ''"
>
        <v-alert
      :value="true"
      type="error"
      color="pink"
      dismissible
      @click="errorName = ''"
    >
      {{ errorName }}
    </v-alert>
</v-flex>

    <v-dialog
      v-model="sentConfirm"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="pink"
        dark
      >
        <v-card-text>
          {{ textMessage }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-layout>

    <v-layout row wrap>
    <v-dialog
    persistent
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Zainteresowania i preferencje zawodowe
        </v-card-title>

        <v-card-text>
          Dla każdego ważne jest, aby lubił wykonywaną pracę. Autotest „Zainteresowania i
preferencje zawodowe” może pomóc Ci zdecydować o tym, jakiego rodzaju pracę
chciałbyś wykonywać. Zawiera bowiem stwierdzenia obrazujące czynności, sposoby
postępowania, zachowania oraz sposoby postrzegania otoczenia niezbędne w różnych zawodach i na różnych stanowiskach pracy. Nie ma dobrych i złych odpowiedzi.
Każde stwierdzenie przeanalizuj tak, jak Ty je odbierasz. Wybierz czy się z nim zgadzasz lub nie zgadzasz.
Do przesłania testu wymagane jest uzupełnienie wszystkich pól. Powodzenia.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="getMe()"
          >
            Nie akceptuję
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Akceptuję
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'autotest',
  data: () => ({
    notSendSecond: false,
    messLocalStorage: false,
    valid: '',
    question: '',
    answer: {},
    dialog: true,
    nameRules: [
      v => !!v || 'Pole jest obowiązkowe',
      v => (v.length >= 3 && v.length <= 60) || 'Imie musi mieć conajmniej 3 znaki'
    ],
    name: '',
    email: '',
    iHaveName: false,
    errorName: '',
    sentConfirm: false,
    phone: '',
    errorMessage: '',
    textMessage: '',
    mapValue: {
      Tak: 1,
      Nie: 0
    },
  }),
  watch: {
    sentConfirm (val) {
      if (!val) return

      setTimeout(() => (this.sentConfirm = false), 4000)
    }
  },
  computed: {
    xsmallList () {
      return this.$vuetify.breakpoint.xs
    },
    smallList () {
      return this.$vuetify.breakpoint.sm
    }
  },
  created: function () {
    // if (localStorage.sendTest) {
    //     this.notSendSecond = localStorage.sendTest
    //     this.messLocalStorage = true
    // }
    const url = 'https://coachingspace.pl/php/test4.php'
    this.$http
      .get(url)
      .then(response => {
        console.log('RRR', response)
        this.question = response.data
      })
      .catch(error => {
        console.log('EEEE', error)
      })
  },
  methods: {
    nextPage () {
      return this.page++
    },
    prevPage () {
      return this.page--
    },
    getMe () {
      return window.location = 'https://coachingspace.pl'
    },
    sendAnswers  () {
      if (this.name === '') {
        this.errorName = 'Musisz podać imię.'
      } else {
        const toSend = {}
        Object.assign(toSend, this.answer)
        toSend.name = this.name
        toSend.email = this.email
        toSend.phone = this.phone
        this.$http
          .post('https://coachingspace.pl/php/post4.php', JSON.stringify(toSend))
          .then(response => {
            // localStorage.sendTest = true
            // this.notSendSecond = true
            this.textMessage = 'Odpowiedzi zostały wysłane!'
            this.sentConfirm = true
            console.log('SSS', response)
          })
          .catch(error => {
            this.textMessage = 'Coś poszło nie tak. Odpowiedzi nie zostały wysłane!'
            this.sentConfirm = true
          })
      }
    },
    clearAnswers () {
      this.answer = {}
    },
  }
}
</script>

<style >
.v-radio-button-end {
    align-items: flex-end;
}

/* .v-list--three-line .v-list__tile {
    height: 120px;
} */
.fixed {
  position: sticky;
  top: 80px;
}
.xsize-list .v-list__tile {
    height: 130px;
    font-size: 13px;
},
.size-list .v-list__tile {
    height: 140px;
}
.dis-padding.v-list {
  padding: 0;
}
</style>
